<div>
  <div class="page-content">
    <a routerLink="/" class="header">
      <img src="/assets/images/marketing/creators/postd_logo_header.png" />
    </a>
    <section class="panel section-1">
      <div class="row row-1">
        <h1>Don't Settle</h1>
        <h2>For a fraction of ad revenue</h2>
        <p class="subheading">
          Set your own price and take<br />
          home 86% of the revenue
        </p>
        <p class="subheading">
          <button class="intro-style gtm_creator_get_started" (click)="getStarted()">
            <span>Get Started FREE ></span>
          </button>
        </p>
      </div>
      <div class="divider"></div>
      <div class="row row-2">
        <h2>WHY CREATE CONTENT FOR POSTD?</h2>
        <ul class="row-list">
          <li>
            <img src="/assets/images/marketing/creators/icon_postd.svg" class="postd-icon" />
            <h3>Creators-first</h3>
            <p>Creators keep 86% of their video revenue. The rest is used to keep the lights on.</p>
          </li>
          <li>
            <img src="/assets/images/marketing/creators/icon_postd.svg" class="postd-icon" />
            <h3>Highly Shareable</h3>
            <p>Easily grab a link to your content and share it with your community!</p>
          </li>
          <li>
            <img src="/assets/images/marketing/creators/icon_postd.svg" class="postd-icon" />
            <h3>No Advertisements</h3>
            <p>Unlike other platforms like Youtube and Facebook, viewers don't see any ads.</p>
          </li>
        </ul>
      </div>
    </section>
    <div class="divider"></div>
    <section class="panel section-2">
      <div class="row">
        <div class="col col-1">
          <h2>See what you could earn</h2>
          <p class="subheading">
            With Postd, you can get paid after earning only $10. Try our calculator and see how much
            you could earn!
          </p>
        </div>
        <div class="col col-2">
          <postd-info-calculator *ngIf="isBrowser" theme="dark"></postd-info-calculator>
        </div>
      </div>
    </section>
    <div class="divider"></div>
    <section class="panel section-3">
      <div class="row">
        <h2>How Postd Works</h2>
        <ul class="row-list">
          <li>
            <img class="icon" src="/assets/images/marketing/creators/3_happy.svg" />
            <div class="description">
              <h3>Open a free account</h3>
              <p>Open a free Postd account using the Transact micropayment system</p>
            </div>
            <img
              src="/assets/images/marketing/creators/icon_1.svg"
              class="svg-number"
              style="margin-left: -12px"
            />
          </li>
          <li>
            <img class="icon" src="/assets/images/marketing/creators/3_price.svg" />
            <div class="description">
              <h3>Set your price</h3>
              <p>Decide what to charge people to view or listen to your content.</p>
            </div>
            <img src="/assets/images/marketing/creators/icon_2.svg" class="svg-number" />
          </li>
          <li>
            <img class="icon" src="/assets/images/marketing/creators/3_play.svg" />
            <div class="description">
              <h3>Post your content</h3>
              <p>Post your content. Users pay per video.</p>
            </div>
            <img src="/assets/images/marketing/creators/icon_3.svg" class="svg-number" />
          </li>
          <li>
            <img class="icon" src="/assets/images/marketing/creators/3_money.svg" />
            <div class="description">
              <h3>Make Money</h3>
              <p>Keep 86% of the revenue! Postd keeps just 14% to keep the service running.</p>
            </div>
            <img src="/assets/images/marketing/creators/icon_4.svg" class="svg-number" />
          </li>
        </ul>
      </div>
    </section>
    <div class="divider"></div>
    <section class="panel section-4">
      <div class="row">
        <div class="col col-1">
          <h2>Getting paid for your videos</h2>
          <p class="subheading">
            It's easy! We'll transfer your money to your bank account or mail you a check! Remember,
            you set the price of your video and get 86% of the revenue.
          </p>
        </div>
        <div class="col col-2"></div>
      </div>
    </section>
    <div class="divider"></div>
    <section class="panel section-5">
      <div class="row row-1">
        <div class="card-list" #featuredPostsCarousel>
          <div class="card" *ngFor="let post of featuredPosts">
            <div class="card-content">
              <postd-post-thumbnail
                [displayOptions]="thumbnailOptions"
                [post]="post"
              ></postd-post-thumbnail>
            </div>
          </div>
        </div>
      </div>
      <div class="divider"></div>
      <div class="row row-2">
        <p class="subheading">
          We built Postd to make more money <strong>for</strong> creators, <br />
          not make money <strong>from</strong> them.
        </p>
      </div>
      <div class="row row-3">
        <p class="subheading">
          <button class="intro-style gtm_creator_get_started" (click)="getStarted()">
            <span>Get Started FREE ></span>
          </button>
        </p>
      </div>
      <div class="row row-4">
        <p class="note">
          <a routerLink="/info/privacy-policy">Privacy Policy</a>
          <a routerLink="/info/faq">FAQ</a>
          <span>&copy; 2024 Postd</span>
        </p>
      </div>
      <div class="row row-5">
        <img class="footer-logo" src="/assets/images/marketing/creators/postd_logo_footer.png" />
      </div>
    </section>
  </div>

  <ng-template #signInModal [postdModalTemplate] let-dialog="dialogInstance">
    <div class="signup-modal">
      <p class="spacer">
        Postd uses your
        <a routerLink="https://transact.io" target="_blank"
          ><img
            src="/assets/images/transact_logo_black.png"
            class="inline-transact-logo"
            alt="Transact"
        /></a>
        account to log in and pay for content.
      </p>
      <p class="modal-buttons">
        <button class="button large primary gtm_login" (click)="loginWithTransact()">
          Log in with Transact
        </button>
      </p>
      <p class="modal-buttons">
        <button class="button secondary gtm_register" (click)="registerWithTransact()">
          Register a new Transact account
        </button>
      </p>
      <span class="info"
        >Creating a new transact account will direct you to a Transact.io page where you only need
        to provide a name, email address, and a password.</span
      >
    </div>
  </ng-template>
</div>
